export default __webpack_public_path__ + "static/media/code-community.4835ac5b.svg";